export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Name"),
        visible: true,
    },
    {
        // [1]
        key: "title",
        label: app.$i18n.t("Title"),
        visible: true,
    },
    {
        // [2]
        key: "subject",
        label: app.$i18n.t("Subject"),
        visible: true,
    },
    {
        // [3]
        key: "description",
        label: app.$i18n.t("Description"),
        visible: true,
    },
    {
        // [4]
        key: "status",
        label: app.$i18n.t("Status"),
        visible: false,
    },
    // {
    //     // [5]
    //     key: "actions",
    //     label: app.$i18n.t("Actions"),
    //     visible: true,
    //     tdClass: "text-center"
    // },
]